import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  PLATFORM_ID,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { environment } from 'src/environments/environment';
import {
  CATEGORY_POPULAR_IMAGE_LIST,
  REGION_SUB_CATEGORY_IMAGE_LIST,
  REGION_CATEGORY_IMAGE_LIST,
} from '../../marketplace/marketplace.model';
import { Location } from '@angular/common';
import { MarketplacePageComponent } from '../../marketplace/marketplace.component';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import {
  BehaviorSubject,
  debounceTime,
  filter,
  firstValueFrom,
  fromEvent,
  Observable,
  Subject,
  Subscription,
  takeUntil,
} from 'rxjs';
import {
  CommunityProduct,
  CommunityProductPagination,
} from 'src/app/shareModule/models/community-product.model';
import { Store, select } from '@ngrx/store';

import { CommonService } from 'src/app/shareModule/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import {
  loadFilteredCommunityProducts,
  selectFilteredCommunityProducts,
} from 'src/app/shareModule/states/filtered-community-product';
import { AppState } from 'src/app/shareModule/states/app.state';
import { BusinessService } from 'src/app/business/business.service';
import { FormControl } from '@angular/forms';
import { selectAllCommunityProducts } from 'src/app/shareModule/states/community-product/community-product.selector';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

import { REQUEST } from '@nguniversal/express-engine/tokens';
import { isPlatformServer } from '@angular/common';
import MobileDetect from 'mobile-detect';
import { loadAllCommunityProducts } from 'src/app/shareModule/states/community-product';
import { Icons, ICONS } from './filter-products.interface';
import { AdServiceService } from 'src/app/ad-service.service';
@Component({
  selector: 'app-filter-products',
  templateUrl: './filter-products.component.html',
  styleUrls: ['./filter-products.component.scss'],
})
export class FilterProductsComponent implements OnInit, OnDestroy {
  // Inputs

  @Input() navFilter: boolean = true;
  item: any = {
    0: {
      items: 2,
    },
  };
  // Output Events
  @Output() onChangeEvent = new EventEmitter<any>();

  @ViewChild('marketplace') marketplacePage: MarketplacePageComponent;
  @ViewChild('SortRental') sortRentalElement: ElementRef;
  @ViewChild('SortDonate') sortDonateElement: ElementRef;
  @ViewChild('SortShoutOut') sortShoutOutElement: ElementRef;

  public userSubRegionId: any = '';
  public categorySuggestions: string[] = [];
  public filterOptionPage: string = 'page1';
  public totalMemberShopProductList: Array<any> = [];
  public filterRegionCategoryList: Array<any> = [];
  public filterRegionSubCategoryList: Array<any> = [];
  public totalProduct: Array<any> = [];
  public memberShopProductList: Array<any> = [];
  public selectedCategoryId: any = null;
  public selectedCategoryName: any = '';
  public memberShopPage: number = 1;
  public memberShopPageSize: number = 1;
  public defaultImg: any = 'default.png';
  public showSubCategoryMenu: boolean = false;
  public enableSubCategorySearch: boolean = false;
  public baseUrl: string = '../../../../../assets/images/shop/';
  public showShopRegionFilter: string = 'search';
  public shopSortBy: string = 'latest';
  public categoryPopularImageList: any = CATEGORY_POPULAR_IMAGE_LIST;
  public subRegionImageList: any = REGION_SUB_CATEGORY_IMAGE_LIST;
  public regionCategoryImageList: Array<any> = REGION_CATEGORY_IMAGE_LIST;
  public selecteMemberShopSubCategory: any = '';
  public screenWidth: number;
  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  public maps: any = {
    search: '',
    postalCode: '',
    radius: 5,
    products: [],
    home: true,
  };
  public showResults: boolean = false;
  public commonModelRef: any = null;
  public popupFilterOptionHeader = '';
  public popupFilterSelectedData = null;
  public memberShopCategoriesList: Array<any> = [];
  public memberShopSubCategoriesList: Array<any> = [];
  public searchBarSubCategoriesList: Array<any> = [];
  public adsList: Array<any> = [];
  public subCategorySearchInput: string = '';
  public currentUrl = this.location.path();
  public bannerImage: string = null;
  public pageTitleContent: string = '';

  products$: Observable<any[]>;

  carouselOptions: any = {
    margin: 15,
    autoWidth: true,
  };
  carouselOptionsBanner: any = {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: false,
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  };
  carouselWithNavOptions: any = {
    spaceBetween: 0,
    slidesPerView: 'auto',
    pagination: false,
  };
  carouselWithNavOptions2: any = {
    spaceBetween: 2,
    slidesPerView: 'auto',
    // loop: true,
    pagination: false,
    grid: {
      rows: this.window.innerWidth > 500 ? 1 : 2,
      fill: 'row',
    },
  };

  public latLong: any = {};
  public basedProduct: string = 'All';
  public reset: any[] = [{}];
  public icons: Icons = ICONS;

  public allProductList: CommunityProductPagination = {
    currentPage: 1,
    data: [],
    lastPage: 1,
    totalCount: 0,
  };

  public deviceType = 1;
  private breakPointObserverSubscription: Subscription | null = null;

  public filteredBottomProducts = [];
  public isLoadingMore: boolean = true;
  /**
   * Constructor
   */
  constructor(
    private location: Location,
    public commonService: CommonService,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private memberNotificationService: MemberNotificationService,
    public roleService: RoleService,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private seoService: SeoService,
    private sharedService: SharedService,
    private businessService: BusinessService,
    private breakPointObserver: BreakpointObserver,
    private customerService: CustomerService,
    private cdr: ChangeDetectorRef,
    private adsService: AdServiceService,
    @Inject('WINDOW') private window: any,
    @Optional() @Inject(REQUEST) private req: any,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    if (isPlatformServer(this.platformId) && req) {
      const userAgent = this.req?.headers['user-agent'] || '';
      const md = new MobileDetect(userAgent);

      if (md.phone()) {
        this.deviceType = 2;
      } else if (md.tablet()) {
        this.deviceType = 4;
      } else {
        this.deviceType = 5;
      }
    }
    this.screenWidth = this.window.innerWidth;
    this.store
      .pipe(select(selectAllCommunityProducts))

      .subscribe((response: any) => {
        this.areProductsLoading = false;
        if (response.currentPage === 1) this.allProductList.data = [];
        if (response?.data)
          this.allProductList = {
            ...response,
            data: [
              ...this.allProductList.data,
              ...structuredClone(response?.data),
            ],
          };
        this.isLoadingMore = false;
        this.cdr.detectChanges();
      });
    this.isLogin = this.local.getUser()?.id ? 1 : 0;
    this.memberShopPageSize = this.window.innerWidth < 768 ? 4 : 8;

    this.commonService.categoryList.subscribe((response: any) => {
      this.memberShopCategoriesList = response
        .map((i) => {
          let output = i;
          (output['iconClass'] = this.icons[i.name]),
            (output['slug'] = i.name?.toLowerCase().replaceAll(' ', '-'));
          output['checked'] = false;
          if (
            output.slug == 'education'
            //||
            // output.slug == 'games-and-hobbies' ||
            // output.slug == 'cleaning' ||
            // output.slug == 'health-&-wellness' ||
            // output.slug == 'childcare' ||
            // output.slug == 'home-improvement' ||
            // output.slug == 'fitness' ||
            // output.slug == 'pets' ||
            // output.slug == 'automobile-&-transport' ||
            // output.slug == 'food-&-beverage' ||
            // output.slug == 'beauty-&-grooming'
          ) {
            output['glow'] = true;
          }
          return output;
        })
        .sort((a, b) => {
          const priority = [
            'Food & Beverage',
            'Education',
            'Automobile & Transport',
            'Beauty & Grooming',
            'Cleaning',
            'Maids, Nannies & Helpers',
            'Home Improvement',
            'Health & Wellness',
            'Electronics',
            'Games and Hobbies',
            'Fitness',
            'Events',
            'Pets',

            'Others',
          ];
          const priorityMobile = [
            'Food & Beverage',
            'Education',
            'Automobile & Transport',
            'Beauty & Grooming',
            'Cleaning',

            'Electronics',
            'Games and Hobbies',

            'Maids, Nannies & Helpers',
            'Home Improvement',
            'Health & Wellness',

            'Fitness',
            'Events',
            'Pets',

            'Others',
          ];
          var array = [];
          if (this.window.innerWidth < 768) {
            array = priorityMobile;
          } else {
            array = priority;
          }
          const aIndex = array.indexOf(a.name);
          const bIndex = array.indexOf(b.name);

          // if both have a known priority
          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;

          // if one has priority, it comes first
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;

          // otherwise, alphabetical
          return a.name.localeCompare(b.name);
        });
      // Move "Others" to the end of the array
      const othersIndex = this.memberShopCategoriesList.findIndex(
        (cat) => cat.name === 'Others'
      );
      if (othersIndex !== -1) {
        const [othersCat] = this.memberShopCategoriesList.splice(
          othersIndex,
          1
        );
        this.memberShopCategoriesList.push(othersCat);
      }

      this.searchBarSubCategoriesList = response
        .map((i) => {
          i.subCategory = i.subCategory.map((j) => {
            return { ...j, checked: true };
          });
          return i.subCategory;
          // @ts-ignore
        })
        .flat();

      this.route.params.subscribe((params) => {
        const { base, category } = params;
        this.reset[0] = {};
        if (base && ['categories', 'region'].includes(base)) {
          if (base == 'categories' && category) {
            const cat = this.memberShopCategoriesList.filter(
              (row) => this.local.sitemapRule(row.slug) == category
            );
            if (cat.length) {
              this.popupFilterSelectedData = cat[0];
              if (this.popupFilterSelectedData.title) {
                this.seoService.update({
                  title: this.pageTitle() ?? this.popupFilterSelectedData.title,
                  description:
                    this.pageTitle() ?? this.popupFilterSelectedData.title,
                });
              }

              // this.getSubRegionByCategory(cat[0]);
              const selected = this.popupFilterSelectedData;
              this.filterByCategory(selected);
            }
          } else {
            this.filterBaseOn(base);
          }
        } else {
        }
      });
      this.cdr.detectChanges();
    });
  }

  private destroy$ = new Subject<void>();
  ngOnDestroy(): void {
    console.log('[Start Destroy] Filter Products Component');
    this.local.clearTimeout(this.timeout1)
    this.local.clearTimeout(this.timeout2)
    this.local.clearTimeout(this.timeout3)
    this.breakPointObserverSubscription?.unsubscribe();
    this.adsService.disposeAds();
    this.destroy$.next();
    this.destroy$.complete();
    console.log('[End Destroy] Filter Products Component');
  }

  public loadCount: number = 0;
  public get filteredCats() {
    return this.memberShopCategoriesList.filter((i) => i.promoBannerImage);
  }
  public handlePromoClick(url) {
    console.log('opening ', url);
    if (url) {
      window.open(url, '_blank');
    }
  }
  /************************************* Ads *******************************************/
  @ViewChild('leftAd') leftAd: ElementRef;
  @ViewChild('rightAd') rightAd: ElementRef;

  public get showAdRight() {
    return this.adsService.showAdRight;
  }
  public get currentRightAd() {
    return this.adsService.currentRightAd;
  }
  public tempCloseAdRight() {
    return this.adsService.tempCloseAdRight();
  }

  public get showAdLeft() {
    return this.adsService.showAdLeft;
  }
  public get currentLeftAd() {
    return this.adsService.currentLeftAd;
  }
  public tempCloseAdLeft() {
    return this.adsService.tempCloseAdLeft();
  }
  /************************************************************************************ */

  ngOnInit(): void {
    this.initData();
    this.local
      .getUserDetailsObserver()
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (user: any) => {
        if (user?.id) {
          const { postalCode, latLong } = user;
          this.userSubRegionId = user?.region;
          if (postalCode) {
            this.maps.postalCode = postalCode;
            this.latLong = user.latLong;
          }
        }
      });
  }

  private initData(): void {
    this.fetchProductRegionCounts();
    this.seoService.update({
      title: 'BEST SERVICES SG',
      description:
        'Explore the best home based services, from business support to repair solutions nearby. Connect with local neighbourhood experts for device repairs, home services, cleaning and more. Empowering communities through Kachiing.',
    });
    this.breakPointObserverSubscription = this.breakPointObserver
      .observe([
        '(max-width: 767px)',
        '(min-width: 768px) and (max-width: 991px)',
        '(min-width: 992px) and (max-width: 1199px)',
      ])
      .subscribe((result) => {
        if (result.breakpoints['(max-width: 767px)']) {
          this.deviceType = 2;
        } else if (
          result.breakpoints['(min-width: 768px) and (max-width: 991px)']
        ) {
          this.deviceType = 3;
        } else if (
          result.breakpoints['(min-width: 992px) and (max-width: 1199px)']
        ) {
          this.deviceType = 4;
        } else {
          this.deviceType = 5;
        }
        console.log(`Device Type set to: ${this.deviceType}`);
      });

    this.adsService.getSiteAds(this.leftAd, this.rightAd);
    this._getAllBizRequest();
    this.fetchSuBregions(true);
    this.loadMore();
  }

  public get filteredSubRegions() {
    // console.log(this.memberShopSubCategoriesList, "this.memberShopSubCategoriesList")
    return this.memberShopSubCategoriesList.filter(
      (subRegion) =>
        subRegion?.regionName == this.selectedRegionForCategoryPopup
    );
  }
  public scrollIntoView(id) {
    document.getElementById(id).scrollIntoView();
  }
  public timeout1: any;
  private fetchSuBregions(selectUserssubRegion = false) {
    const subs = this.filterRegionSubCategoryList
      ? Array.from(
        this.filterRegionSubCategoryList
          .filter((val) => {
            return val.checked;
          })
          .map((val) => val.categorieChildId)
      )
      : null;

    if (subs && this.popupFilterSelectedData?.id) {
      subs.push(this.popupFilterSelectedData?.id);
    }
    if (selectUserssubRegion) {
      const qsubs = this.route.queryParams.subscribe((param) => {
        let selectedSubRegions = new Set();
        if (param['region']) {
          console.log('params has region');
          selectedSubRegions = new Set(
            param['region']
              .split('_')
              .map((row: any) => row.replaceAll('-', ' ').toLowerCase())
          );
          this.timeout1 = setTimeout(() => {
            this.fetchSubRegionInfos(selectedSubRegions);
          });
        } else {
          this.fetchSubRegionInfos();
        }
      });
    }
  }

  private regionCounts = {};
  private async fetchProductRegionCounts() {
    this.auth
      .getSubRegionProductCounts()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (results: any) => {
          this.regionCounts = results.body;
        },
        error: console.error,
      });
  }

  private fetchSubRegionInfos(selectedSubRegions = new Set()) {
    this.commonService.subRegionListBaseProductObserver
      .pipe(takeUntil(this.destroy$))
      .subscribe((response) => {
        this.memberShopSubCategoriesList = Array.from(
          response?.map((i: any) => {
            return {
              regionId: i.regionId,
              regionName: i.regionName,
              name: i.regionName,
              subRegionId: i.subRegionId,
              id: i.subRegionId,
              region: i.name,
              metadata: i.metadata,
              schema: i.schema,
              checked: selectedSubRegions.has(i?.name?.toLowerCase()),
              // selectUserssubRegion &&
              // (this.isLogin
              //   ? this.userSubRegionId
              //   : this.userPreferedSubRegion) == i.subRegionId,
              productCount: i.productCount,
              allRegionProductCount: i?.allRegionProductCount,
            };
          })
        );
        // console.log('filtered', this.memberShopSubCategoriesList.map(x => [x.checked, x.region],), selectedSubRegions)
      });
  }
  @ViewChild('CategorySearch') CategorySearch: ElementRef;
  @ViewChild('sellAndBuy') sellAndBuy!: ElementRef;

  ngAfterViewInit(): void {
    this.route.queryParams.subscribe((param) => {
      if (param['sortBy']) {
        this.seoService.update({
          main_title: '- KACHIING ' + param['sortBy'].toUpperCase(),
        });

        this.basedProduct = param['sortBy'];
      }
    });

    if (
      this.showShopRegionFilter == 'search' &&
      !this.route.snapshot.queryParams['product']
    ) {
      this.seoService.updateSchema('homepage');
      this.seoService.updateSchema('homepage_1');
    }
    // this.seoService.updateSchema('organization')

    if (this.CategorySearch?.nativeElement)
      fromEvent(this.CategorySearch?.nativeElement, 'keyup')
        .pipe(
          debounceTime(300) // 300ms
        )
        .subscribe(() => {
          this.productsSearch(this.subCategorySearchInput);
        });

    if (this.sharedService.isBrowser() && this.sellAndBuy?.nativeElement) {
      const children = this.sellAndBuy?.nativeElement?.querySelectorAll(
        '.sell-and-buy__item'
      );

      children.forEach((child: HTMLElement) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('animate');
              } else {
                entry.target.classList.remove('animate');
              }
            });
          },
          { threshold: 0.5 }
        );

        observer.observe(child);
      });
    }
  }

  private readonly USER_SUBREGION_PREF_ID = 'USER_SUBREGION_PREF_ID';

  private set userPreferedSubRegion(subRegionId) {
    if (typeof document !== 'undefined' && this.sharedService.isBrowser()) {
      if (localStorage && !localStorage.getItem(this.USER_SUBREGION_PREF_ID)) {
        localStorage.setItem(this.USER_SUBREGION_PREF_ID, subRegionId);
      }
    }
  }

  private get userPreferedSubRegion() {
    if (typeof document !== 'undefined' && this.sharedService.isBrowser()) {
      return localStorage.getItem(this.USER_SUBREGION_PREF_ID);
    } else {
      return null;
    }
  }

  filterByCategory(selected: any) {
    this.filterBaseOn('categories');
    if (this.sharedService.isBrowser()) {
      this.popupFilterSelectedData?.subCategory?.map((row) => {
        if (row.checked) {
          this.seoService.addMetaTags(row?.metaConfig);
          this.seoService.updateSchema('custom', row?.codeSchema);
        }
      });
    }

    const selectedRegion = Array.from(
      this.memberShopSubCategoriesList
        .filter((val) => val.checked)
        .map((val) => val.subRegionId)
    );

    if (!selected) {
      this.enableSubCategorySearch = true;
      this.getSelectedMemberShopProductList(
        [],
        Array.from(new Set(selectedRegion))
      );
      return;
    }

    this.bannerImage = '';
    if (selected?.bannerImage)
      this.bannerImage = this.imgUrl + selected.bannerImage;

    this.selectedCategoryId = selected.id;
    this.selectedCategoryName = selected?.name;

    let subCategoryIds = [];

    this.route.queryParams.subscribe((param) => {
      if (param['region']) {
        const regionParams = param['region']
          .split('_')
          .map((row: any) => row.replaceAll('-', ' ').toLowerCase());
        if (regionParams.length > 0) {
          console.log({ regionParams });
          // Get Region Filter
          this.popupFilterOptionHeader = 'Category';
          this.memberShopSubCategoriesList.map((row: any) => {
            // if (regionParams.includes(row.region.toLowerCase())) {
            //   //console.log({ row })
            //   row.checked = true;
            //   selectedRegion.push(row.id);
            // }
            return row;
          });
        }
      }

      // Get Sub Category Filter
      this.typesForCurrentCategory = [];
      this.filterRegionSubCategoryList = selected?.subCategory;
      if (param['sub']) {
        this.filterRegionSubCategoryList = selected?.subCategory.map(
          (row: any) => {
            row.checked = false;
            if (
              param['sub']
                .split('_')
                .includes(row.categoryName.replaceAll(' ', '-').toLowerCase())
            ) {
              row.checked = true;
            }
            return row;
          }
        );
      }
      subCategoryIds = [
        selected.id,
        ...this.filterRegionSubCategoryList.map((row) => row.categorieChildId),
      ];
    });
    this.getSelectedMemberShopProductList(
      subCategoryIds.length ? subCategoryIds : this.selectedCategoryId,
      Array.from(new Set(selectedRegion))
    );
    this.enableSubCategorySearch = true;
  }

  handleError(event: any): void {
    (event.target as HTMLImageElement).src = this.baseUrl + this.defaultImg;
  }

  public get isOnBottomCategoryMode(): boolean {
    return (
      this.showShopRegionFilter === 'search' && !this.subCategorySearchInput
    );
  }

  public allBottomProducts = [];
  public timeout2: any;
  async pageTitle() {
    // Wait until both categories and regions are loaded (not empty arrays)
    // If either is still loading, wait for them to be populated
    const waitForData = async () => {
      while (
        !this.filterRegionSubCategoryList ||
        this.filterRegionSubCategoryList.length === 0 ||
        !this.memberShopSubCategoriesList ||
        this.memberShopSubCategoriesList.length === 0
      ) {
        this.timeout2 = await new Promise((resolve) => setTimeout(resolve, 50));
      }
    };

    await waitForData();

    let regions = this.memberShopSubCategoriesList
      .filter((row: any) => row.checked)
      .map((row: any) => row.region)
      .join(' ,');

    let categories = this.filterRegionSubCategoryList
      .filter((row: any) => row.checked)
      .map((row: any) => row.categoryName)
      .join(' ,');

    if (regions.length > 0) regions = `in ${regions}`;
    if (categories.length > 0) categories = `(${categories})`;

    let title = `${this.popupFilterSelectedData?.name} ${categories} ${regions}`;
    let h1Content = this.local.getStringBetween(
      this.popupFilterSelectedData?.content,
      '>',
      '</h1>'
    );
    if (h1Content != '' && h1Content != 'null' && h1Content != null)
      title += ' | ' + h1Content;

    this.seoService.update({
      title: title,
      description: title,
    });

    this.pageTitleContent = title?.split('|')[0];
    return this.pageTitleContent;
  }

  public getSubCategoryList(categoryId: any) {
    this.selecteMemberShopSubCategory = categoryId;
    this.selectedCategoryId = categoryId;
    this.auth
      .getAllMemberShopSubCategory({
        categoryId: categoryId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.getSelectedMemberShopProductList(
          this.selectedCategoryId,
          response.body.map((i) => i.id)
        );
      });
  }

  filterCategory: any = {};
  public getSelectedMemberShopProductList(
    categoryId: any,
    subRegionId: Array<any>
  ): void {
    //this.commonService.subRegionAllRegionId,
    this.memberShopProductList = [];
    //console.log('Called with', {arguments})
    if (
      subRegionId &&
      subRegionId.includes(this.commonService.subRegionAllRegionId)
    ) {
      subRegionId = [];
    }

    this.filterCategory = {
      categoryId: categoryId,
      subRegionId: [...subRegionId],
    };
    this.loadMore();
  }

  resetDisplayedProducts() {
    this.memberShopProductList = [];
    this.loadMore();
  }

  public clearFilter() {
    this.filterOptionPage = 'page1';
    this.subCategorySearchInput = this.popupFilterOptionHeader = '';
    this.enableSubCategorySearch = this.showSubCategoryMenu = false;
    this.selectedCategoryId = null;
    this.getFilterItem();
    this.onChangeEvent.next(null);
    this.typesForCurrentCategory = [];
  }

  public areProductsLoading = false;
  loadMore(page: number = 1, search?: string) {
    this.areProductsLoading = true;
    //console.trace();
    console.log('[DEFAULT] loadAllCommunityProducts');
    if (this.showShopRegionFilter == 'search') this.filterCategory = {};
    //console.log(this.filterCategory, "this.filterCategory")
    if (this.sharedService.isBrowser()) {
      this.isLoadingMore = true;
      this.store.dispatch(
        loadAllCommunityProducts({
          search,
          basedProduct: this.basedProduct.toLowerCase(),
          page: page,
          orderBy: this.shopSortBy,
          ...this.filterCategory,
        })
      );
    }
  }

  public nextPage(): void {
    this.shopSortBy = 'popular';
    //console.log('NEXT PAGE', this.totalMemberShopProductList);
    let filterValue = this.totalMemberShopProductList;
    // *** For recommended ***
    if (this.showShopRegionFilter == 'recommended') {
      filterValue = filterValue.filter(
        (i) => i.isRecommendedProduct && i.foodFavoritesCount >= 10
      );
    } else if (this.showShopRegionFilter == 'vote') {
      filterValue = filterValue.filter((i) => i.isRecommendedProduct);
    } else if (this.showShopRegionFilter == 'bless') {
      filterValue = filterValue.filter((i) => i?.type == 'bless');
    } else {
      filterValue = filterValue.filter(
        (i) => !i?.isRecommendedProduct && i?.type != 'bless'
      );
    }
    // *** For recommended ***
    // this.memberShopProductList = this.sortByProp(filterValue.slice((this.memberShopPage - 1) * this.memberShopPageSize, (this.memberShopPage - 1) * this.memberShopPageSize + this.memberShopPageSize), "foodFavoritesCount");
    this.memberShopProductList = this.sortByProp(
      filterValue,
      'foodFavoritesCount'
    );
  }

  public filterBaseOn(type: string): void {
    // this.clearFilter();
    this.seoService.removeSchema();
    if (type == 'search') {
      this.seoService.updateSchema('homepage');
      this.seoService.updateSchema('homepage_1');
    }
    this.sortShopBy('latest');
    this.selecteMemberShopSubCategory = '';
    this.showShopRegionFilter = type;
    this.showSubCategoryMenu = false;
  }

  public replaceState(type: string) {
    const basePath = this.isLogin == 1 ? 'community/me' : '';
    this.location.replaceState(basePath + `/${type}`);
    // this.router.navigateByUrl(`/${basePath}/${type}`);
  }

  public selectFoodsCategory() {
    const foodsCategory = this.memberShopCategoriesList.find((cat) =>
      cat?.name?.toLowerCase()?.includes('food')
    );

    this.fetchSuBregions();
    this.openSubCatFilterPopUp(null, 'Category', foodsCategory);
  }

  public showVerifiedOnly = false;
  public sortShopBy(type: string): void {
    this.basedProduct = 'all'; //cause only rental uses this and it doesn't call this function
    this.shopSortBy = type;
    this.loadMore();
  }

  public sortByProp(arrayObj: Array<any>, prop: any): Array<any> {
    return arrayObj.sort((x: any, y: any) => y[prop] - x[prop]);
  }

  public getShopProductListByRegion(regionName: any): void {
    this.selectedCategoryName = '';
    this.selecteMemberShopSubCategory = regionName;

    if (
      this.memberShopSubCategoriesList &&
      this.memberShopSubCategoriesList.length > 0
    ) {
      this.selectedCategoryId = this.memberShopCategoriesList.map((i) => i.id);
      this.getSelectedMemberShopProductList(
        this.selectedCategoryId,
        this.memberShopSubCategoriesList.map((i) => i.id)
      );
    } else {
      this.nextPage();
    }
  }

  public viewProductDetails(product, dissmissAll = true): void {
    this.marketplacePage.enableMemberShop = true;
    this.marketplacePage.viewProduct(product, false, dissmissAll);
  }

  openFilterModal(modal: any) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: 'lg',
    });
  }

  public timeout3: any;
  handlePopularCategory(val: any) {
    if (val == 'Recomm') {
      this.showShopRegionFilter = 'recommended';
    } else if (val == 'Donations') {
      this.showShopRegionFilter = 'bless';
    } else {
      this.showShopRegionFilter = 'categories';
      // ******   Avoid direct accessing element this can trigger render randomly ******
      this.timeout3 = setTimeout(() => {
        const element = document.getElementById(
          val.toLowerCase().replaceAll(' ', '')
        );
        if (element) element.click();
      }, 500);
    }
  }

  public identify(index, item) {
    return item.id;
  }

  private correctRegionProductCounts() {
    /**
     *   API returns key value pair in hashmap style object in format ${subRegionId}x${categoryId} = productCount
     *   the function is on ngOnInit => fetchProductRegionCounts called once to get counts of every subcategory and subregion pair
     *   so this just get counts from variable storing the count pairs =>regionCounts
     *
     */

    const selectedSubCategories = this.filterRegionSubCategoryList
      .filter((i) => {
        return i.checked;
      })
      .map((i) => i.categorieChildId);

    const subRegions = this.memberShopSubCategoriesList; //bad naming!!!!

    for (const subRegion of subRegions) {
      subRegion.productCount = 0;
      if (selectedSubCategories.length == 0) {
        const KEY = `${subRegion.subRegionId}x`;

        subRegion.productCount = this.regionCounts[KEY] ?? 0; //incase of null or undefined
      } else {
        for (const selectedSubCategoryId of selectedSubCategories) {
          const KEY = `${subRegion.subRegionId}x${selectedSubCategoryId}`;

          subRegion.productCount += this.regionCounts[KEY] ?? 0;
        }
      }
    }
    this.cdr?.detectChanges(); //sometimes doesn't update fast
  }

  public async openSubCatFilterPopUp(
    modal: any,
    mode: string,
    selected: any,
    openPopup: boolean = false
  ) {
    // await this.fetchProductRegionCounts()
    this.correctRegionProductCounts(); //update the counts of the subregions based on selected categories

    this.bannerImage = '';
    if (selected?.bannerImage)
      this.bannerImage = this.imgUrl + selected.bannerImage;

    this.selectedRegionForCategoryPopup = '';
    this.selectedCategoryName = '';
    this.selectedCategoryId = '';
    this.filterOptionPage = 'page1';
    this.popupFilterOptionHeader = mode;
    this.popupFilterSelectedData = selected;
    this.pageTitle();
    this.modalService.dismissAll();

    if (openPopup) {
      // If Not Logged In //used to have !this.isLogin && !this.userPreferedSubRegion) ||
      this.commonModelRef = this.modalService.open(modal, {
        //size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
      });
    }

    this.memberShopCategoriesList = this.memberShopCategoriesList.map((i) => {
      i['checked'] = false;
      return i;
    });

    if (mode == 'Category') {
      this.filterByCategory(selected);
      if (selected) {
        this.replaceState(
          'categories/' + this.local.sitemapRule(selected.slug)
        );
        this.saveRegionParams(true);
      } else {
        this.replaceState('categories');
      }
    }
    if (selected) {
      this.filterRegionSubCategoryList.forEach((subCategory) => {
        //console.log({subCategory, selected})
        if (subCategory.categorieParentId == selected?.id) {
          //if null as in case of all category then unselecting all of them
          subCategory.checked = true;
        } else {
          subCategory.checked = false;
        }
      });
    } else {
      this.filterRegionSubCategoryList = [];
      this.typesForCurrentCategory = [];
    }
  }

  public multiSelect(option) {
    //this.filterOptionPage = 'page2';
    this.getFilterItem();

    this.commonModelRef ? this.commonModelRef.close() : '';
  }

  public clearSubFilter(item): void {
    item.checked = false;
    this.getFilterItem();
  }

  public handleSearch(value: any) {
    this.maps.radius = value;
    document.getElementById('btnSearchGmap').click();
  }

  public getFilterItem(): void {
    if (
      this.popupFilterOptionHeader == 'Region' ||
      this.popupFilterOptionHeader == 'Category'
    ) {
      this.onChangeEvent.next({
        category: this.selectedCategoryName,
        subRegion: this.memberShopSubCategoriesList
          .filter((i) => i.checked)
          .map((i) => i.region)
          .join('|'),
      });

      this.typesForCurrentCategory = [];
      let filterItem = [];
      // @ts-ignore
      const checkedRegion = this.memberShopSubCategoriesList.filter(
        (i) => i.checked
      );
      let regionItems = checkedRegion.map((i) => i.id).flat();

      checkedRegion.forEach((item: any) => {
        this.seoService.addMetaTags(item.metadata);
        if (item.schema) this.seoService.updateSchema('custom', item.schema);
      });

      // Set REGION to URL QUERY PARAMS

      if (this.popupFilterOptionHeader == 'Category') {
        filterItem = [this.popupFilterSelectedData];
      } else {
        filterItem = this.memberShopCategoriesList.filter((i) => i.checked);
      }

      if (
        filterItem &&
        filterItem.length > 0 &&
        regionItems &&
        regionItems.length > 0
      ) {
        this.filterRegionCategoryList = [...filterItem];
        // @ts-ignore
        this.filterRegionSubCategoryList = filterItem
          .filter((i) => i)
          .map((i) => {
            i.subCategory = i.subCategory.map((j) => {
              return { ...j, checked: true };
            });

            return i.subCategory;
            // @ts-ignore
          })
          .flat();
      } else {
        this.filterOptionPage = 'page1';
        this.filterRegionSubCategoryList = [];
        this.filterRegionCategoryList = [];
      }

      this.saveRegionParams();

      // @ts-ignore
      this.selectedCategoryId = [
        ...this.filterRegionCategoryList.filter((i) => i).map((i) => i.id),
        ...this.filterRegionSubCategoryList
          .filter((i) => i)
          .map((i) => i.categorieChildId),
      ].flat();

      if (this.selectedCategoryId.length < 1)
        this.selectedCategoryId = this.popupFilterSelectedData?.id;

      this.getSelectedMemberShopProductList(
        this.selectedCategoryId,
        regionItems
      );
    } else {
      let filterInput = this.memberShopCategoriesList
        .filter((i) => i.checked)
        .map((i) => i.id)
        // @ts-ignore
        .flat();
      this.getSubCategoryList(filterInput);
      this.showSubCategoryMenu = true;
    }
  }

  public saveRegionParams(onlyRegion: boolean = false) {
    const checkedRegion = this.memberShopSubCategoriesList.filter(
      (i) => i.checked
    );

    if (checkedRegion.length > 0) {
      const selectedRegion = checkedRegion.map((row: any) =>
        row.region.replaceAll(' ', '-')
      );

      const queryParams = this.local.buildQuery({
        region: selectedRegion.join('_').toLowerCase(),
        sub: onlyRegion
          ? ''
          : this.filterRegionSubCategoryList
            .map((row) => row.categoryName.replaceAll(' ', '-'))
            .join('_')
            .toLowerCase(),
      });
      this.location.replaceState(
        `${window.location.pathname?.split('?')[0]}?${queryParams}`
      );
    } else {
      this.location.replaceState(`${window.location.pathname?.split('?')[0]}`);
    }
  }

  public hideMe(dataOne: Array<any>, dataTwo: Array<any>) {
    return (
      (dataOne && dataOne.filter((i) => i?.checked).length > 0) ||
      (dataTwo && dataTwo.filter((i) => i?.checked).length > 0)
    );
  }

  public selectedData: any = null;
  public getSubRegionByCategory(selectedCategory) {
    this.selectedData = [selectedCategory.id];
    this.selectedData = [
      ...this.selectedData,
      ...(selectedCategory.subCategory
        ? selectedCategory.subCategory.map((i) => i.categorieChildId)
        : []),
    ];

    this.nextPage();
  }

  sortByMenu: String[] = ['All', 'Recommended', 'Services', 'Rental', 'Donate'];

  public handleBasedProduct(value: string) {
    this.basedProduct = value;

    if (this.showShopRegionFilter == 'search') {
      this.loadMore();
    } else {
      this.multiSelect(
        this.popupFilterOptionHeader == 'Region'
          ? this.memberShopSubCategoriesList
          : this.memberShopCategoriesList
      );
    }
  }

  public handleKeywordsValue(value: string) {
    this.maps.search = value;
  }

  public regionSplit(name: string): string {
    return name && name.includes('|') ? name.split('|')[1] : '';
  }

  public filterNextPage(page: string) {
    if (this.memberShopSubCategoriesList.filter((i) => i.checked).length == 0) {
      this.toastr.error('Select Sub Region!');
      return;
    }
    this.filterOptionPage = page;
    this.popupFilterOptionHeader = page == 'page2' ? 'Category' : 'Region';
  }

  //self documnenting code
  private _deselectAllThenSelectClicked(
    clickedSubCategory: any,
    allSubCategorist: any[]
  ) {
    // //so this checks if the selected category is unselected but the others are selected
    // //this means that all were selected before
    // const checkIfRestAreClickedAndClickedIsntChecked = (cat) =>
    //   (cat.categorieChildId == clickedSubCategory.categorieChildId &&
    //     clickedSubCategory.checked == false) ||
    //   (cat.categorieChildId != clickedSubCategory.categorieChildId &&
    //     cat.checked);

    // if (allSubCategorist.every(checkIfRestAreClickedAndClickedIsntChecked)) {
    //   //de select all except the clicked one
    //   allSubCategorist.forEach((cat) => (cat.checked = false));
    //   clickedSubCategory.checked = true;
    // }
    allSubCategorist.forEach((cat) => (cat.checked = false));
    clickedSubCategory.checked = true;
  }
  /******************************** Code related to types *************************/
  public typesForCurrentCategory = [];
  public getTypesForCategory(catId) {
    this.auth.getTypesOfCategory(catId).subscribe({
      next: (data: any) => {
        this.typesForCurrentCategory = data.data;
      },
    });
  }
  public get isBrowser(): boolean {
    return this.sharedService.isBrowser();
  }
  public searchProds = [];
  @ViewChild('seeProductList')
  public seeProductList: TemplateRef<any>;
  public selectedTypeOneId = null;
  public selectedTypeTwoId = null;

  public searchUsingType(type, i) {
    if (type.type == 1) {
      if (this.selectedTypeOneId == type?.id) {
        this.selectedTypeOneId = null
      } else {
        this.selectedTypeOneId = type?.id;

      }

    } else if (type.type == 2) {
      if (this.selectedTypeTwoId == type?.id) {
        this.selectedTypeTwoId = null
      } else {
        this.selectedTypeTwoId = type?.id;

      }
    } else {
      console.error("unknown type grouping!", type?.type)
      return
    }
    if (!this.selectedTypeOneId && !this.selectedTypeTwoId) {
      this.getShopProductListBySubRegionAndCategory(this.memberShopSubCategoriesList, this.filterRegionSubCategoryList, i)
      return;
    }

    this.allProductList.data = [];
    this.allProductList.currentPage = 1;

    this.auth
      .fetchProductsBasedOnTypes({ types: Array.from([this.selectedTypeOneId, this.selectedTypeTwoId].filter(x => x)), page: 1 })
      .subscribe({
        next: (data: any) => {
          this.allProductList.data = data.data;

          this.allProductList.lastPage = data.lastPage;
          this.cdr.detectChanges()
          //this.modalService.open(this.seeProductList, { size: 'md' });
        },
        error: (err) => {
          console.error(err);
          this.toastr.error('Error something went wrong while fetching ');
        },
      });
  }

  /****************************************************************************** */

  public getShopProductListBySubRegionAndCategory(
    subRegion: any,
    selectedCategoryId: any,
    clicked = null
  ) {
    if (clicked) {
      this._deselectAllThenSelectClicked(clicked, selectedCategoryId);
      console.log({ clicked });
      this.getTypesForCategory(clicked.categorieChildId);
    }

    if ((this.filterOptionPage = 'page2')) {
      let ids = selectedCategoryId
        .filter((i) => i.checked)
        .map((i: any) => i.categorieChildId);
      if (ids && ids.length == 0) {
        ids = this.filterRegionCategoryList.map((i: any) => i.id);
      }
      this.selectedCategoryId = ids;
    } else {
      this.selectedCategoryName = selectedCategoryId?.name || '';
    }

    let selectedSubRegionId = subRegion
      .filter((i) => i?.checked)
      .map((i) => i?.id)
      .flat();

    this.onChangeEvent.next({
      category: this.selectedCategoryName,
      subRegion: subRegion
        .filter((i) => i.checked)
        .map((i) => i.region)
        .join('|'),
    });

    const queryParams = this.local.buildQuery({
      sub: selectedCategoryId
        .filter((i) => i?.checked)
        .map((row) => row.categoryName.replaceAll(' ', '-'))
        .join('_')
        .toLowerCase(),
    });
    this.location.replaceState(
      `${window.location.pathname?.split('?')[0]}?${queryParams}`
    );
    this.getSelectedMemberShopProductList(
      this.selectedCategoryId,
      selectedSubRegionId
    );
    this.commonModelRef ? this.commonModelRef.close() : '';
    //this.fetchSuBregions();
  }

  public getAds(category: string, memberShopSubRegion: string): void {
    this.auth
      .getMemberShopAdsBy(category, memberShopSubRegion)
      .pipe(takeUntil(this.destroy$))
      .subscribe((resp: ApiResponse) => {
        this.adsList = resp.body;
      });
  }

  goBack() {
    this.commonService.goBack();
  }

  public productsSearch(value: string) {
    this.loadMore(1, value);
  }

  public checkCheckedData(event, arrayData: Array<any>, type) {
    let count = type == 'region' ? 3 : 1;
    let checkedItem = arrayData?.filter((i: any) => i.checked);
    if (arrayData.length) {
      this.userPreferedSubRegion = arrayData.find(
        (i: any) => i.checked
      ).subRegionId;
    }

    if (event.currentTarget.checked && checkedItem.length > count) {
      checkedItem[0].checked = false;
    }
  }
  openSearchBar: boolean = false;
  public searchSubCategory(): void {
    this.enableSubCategorySearch = true;
    this.categorySuggestions = [];
    this.getShopProductListBySubRegionAndCategory(
      this.memberShopSubCategoriesList,
      this.filterRegionSubCategoryList
    );
  }

  public clearSubCategorySearch(): void {
    this.subCategorySearchInput = '';
    this.enableSubCategorySearch = false;
    this.categorySuggestions = [];
    this.filterRegionSubCategoryList = [];
    this.typesForCurrentCategory = [];
    this.getShopProductListBySubRegionAndCategory(
      this.memberShopSubCategoriesList,
      this.filterRegionSubCategoryList
    );
  }

  public selectedRegionForCategoryPopup: any;
  private selectedRegion = null;
  public filterSubRegionForCategoryPopUp(selectedRegion) {
    this.selectedRegion = this.selectedRegion;

    this.selectedRegionForCategoryPopup = selectedRegion?.name;
  }

  trackById(index: number, item: any): any {
    return item.id; // Assuming `id` is a unique identifier for each product in the list
  }

  public allBizReq: Array<any> = [];
  private _getAllBizRequest(): void {
    this.businessService
      .getAllBiz()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: ApiResponse) => {
        this.allBizReq = (response?.body || [])
          .filter((i) => i.status == 'active')
          .map((i) => {
            return { name: i?.company_name, indexImage: i?.image_path };
          });
      });
  }
}
